import { Injectable } from '@angular/core';
import { CustomHttp, ApiConstants } from '../../shared';

export class ScheduledAction {
    id?: number;
    user: string;
    parrotId: string;
    action: string;
    actionDate: string;
    completed?: Boolean;
    cancelledUser?: string;
    cancelledTimestamp?: Date;
}

@Injectable()
export class SchedulingService {
    constructor(private customHttp: CustomHttp, private apiConstants: ApiConstants) {}

    getScheduledActions(user: string, action: string, parrotId: string,
        completed: 'true' | 'false') : Promise<ScheduledAction[]>
    {
        let url = `${this.apiConstants.ENDPOINT_SCHEDULING}`;
        if (user || action || parrotId) {
            url = url + '?' + `${user ? 'user=' + user : ''}${action ? 'action=' + action : ''}` +
                `${parrotId ? 'parrot_id=' + parrotId : ''}`;
            if (completed) {
                url = url + `&completed=${completed}`;
            }
        }
        return this.customHttp.get(url);
    }

    createScheduledAction(scheduledAction: ScheduledAction) {
        const url = `${this.apiConstants.ENDPOINT_SCHEDULING}`;
        return this.customHttp.post(url, scheduledAction);
    }

    cancelScheduledAction(id: number, cancelledUser: string) {
        const url = `${this.apiConstants.ENDPOINT_SCHEDULING}/cancel`;
        const body = {
            id, cancelledUser
        };
        return this.customHttp.put(url, body);
    }
}


// WEBPACK FOOTER //
// ./src/app/catalogue/scheduling/scheduling.service.ts